import * as React from "react"

import { MoveHandle } from "Catalog/Edit/shared/components/Navigator"
import { ItemRenderProps } from "Catalog/Edit/shared/components/Navigator/types"
import { IProduct } from "shared/hubrise/models"

import { StyledProduct, Name } from "./Styles"

interface ItemProductProps {
  product: IProduct
  itemRenderProps: ItemRenderProps
}

const ItemProduct = ({ product, itemRenderProps }: ItemProductProps): JSX.Element => {
  return (
    <StyledProduct {...itemRenderProps}>
      <Name isEnabled={product.skus.some((sku) => sku.restrictions.enabled)}>{product.name}</Name>
      <MoveHandle {...itemRenderProps} />
    </StyledProduct>
  )
}

export default ItemProduct
